import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  IGetLessonDate,
  IGetTuitions,
  ILessonDateReq,
} from '../models/transferPay.model';
import QueryString from 'qs';

const uri = '/mgmt/transfer-pay';

export const getStartLessonDate = (
  classCode: string,
  param: ILessonDateReq,
): AxiosPromise<IGetLessonDate> => {
  const qsParam = QueryString.stringify(param);
  return axios.get(`${uri}/${classCode}/start?${qsParam}`);
};

export const getTuitions = (
  classCode: string,
  param: { timetableCode?: number | null },
): AxiosPromise<IGetTuitions> => {
  const qsParam = QueryString.stringify(param);
  return axios.get(`${uri}/${classCode}?${qsParam}`);
};
